export function cleanupModalBody () {
  if (document.querySelector(".modal.show")) return

  document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove())
  document.body.classList.remove("modal-open")
  document.body.style.removeProperty("overflow")
  document.body.style.removeProperty("padding-right")
  document.documentElement.style.removeProperty("overflow")
  document.documentElement.style.removeProperty("padding-right")
}
